import { useState } from 'react';
import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import { urlValidations } from 'modules/campaigns/config';
import { useUrlValidatedInput } from 'modules/campaigns/modules/creative-creator/components/UrlList/useUrlValidatedInput';
import { useGetPixelTesterUrl } from '../../../hooks/useGetPixelTesterUrl';

export const useUrlInputWithValidation = (validationsProp = urlValidations) => {
    const {
        cacheValue: websiteUrl,
        onChange,
        onBlur,
        showSuccessIcon,
        isValidationsRunning,
        indicationData,
    } = useUrlValidatedInput({
        field: 'pixelTesterWebsiteUrl',
        validations: validationsProp,
    });

    const [pixelTesterUrl, setPixelTesterUrl] = useState(null);
    const getPixelTesterUrl = useGetPixelTesterUrl();

    const handleGenerateClick = async () => {
        const url = await getPixelTesterUrl(websiteUrl);
        setPixelTesterUrl(url);
    };

    const isPixelNotFoundError = indicationData?.message?.props?.id === 'validations.error.field.url.pixel';

    const disableQrCodeButton =
        (indicationData.indicationType === INDICATION_TYPES.ERROR && !isPixelNotFoundError) || isValidationsRunning;

    return {
        websiteUrl,
        showSuccessIcon,
        isValidationsRunning,
        indicationData,
        pixelTesterUrl,
        onChange,
        handleGenerateClick,
        onBlur,
        disableQrCodeButton,
    };
};
